import {createContext, useContext, useState} from "react";
import React from 'react'

const GraphRelationContext = createContext();

export function GraphRelationProvider({children}) {

    const [activeButtonId, setActiveButtonId] = useState(null);
    const [startPoint, setStartPoint] = useState(null);
    const [endPoint, setEndPoint] = useState(null);
    const [graphMoveDirection, setGraphMoveDirection] = useState(null); // left,right,top,bottom
    const [graphMoveSpeedMultiplayer, setGraphMoveSpeedMultiplayer] = useState(1);
    return (
        <GraphRelationContext.Provider
            value={{
                activeButtonId,
                setActiveButtonId,
                startPoint,
                setStartPoint,
                endPoint,
                setEndPoint,
                graphMoveDirection,
                setGraphMoveDirection,
                graphMoveSpeedMultiplayer,
                setGraphMoveSpeedMultiplayer
            }}>
            {children}
        </GraphRelationContext.Provider>
    );
}

export function useGraphRelationContext() {
    return useContext(GraphRelationContext);
}


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/services/ButtonRelationService.js